// VueLazyLoad 插件
// 迁移自 main.js 中的懒加载配置

import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'

Vue.use(VueLazyLoad, {
  error: '../static/img/tzb.jpg',
  loading: '../static/img/tzb.jpg'
})
